/**
 * Convierte un slug en un nombre legible
 * @param slug - El slug a convertir (ej: "acabados-y-terminaciones")
 * @returns El nombre legible (ej: "Acabados y Terminaciones")
 */
export function slugToReadableName(slug: string): string {
  if (!slug) return "";

  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/**
 * Convierte un nombre legible en un slug
 * @param name - El nombre a convertir (ej: "Acabados y Terminaciones")
 * @returns El slug (ej: "acabados-y-terminaciones")
 */
export function nameToSlug(name: string): string {
  if (!name) return "";

  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remover acentos
    .replace(/[^a-z0-9\s-]/g, "") // Solo letras, números, espacios y guiones
    .replace(/\s+/g, "-") // Espacios a guiones
    .replace(/-+/g, "-") // Múltiples guiones a uno solo
    .trim();
}
